import { motion } from "framer-motion";
import { fadeIn } from "../utils/framer";
import { useState, useEffect } from "react";

const Nosotros = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust the breakpoint as needed
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {isMobile ? (
        <div className="md:mx-48 sm:mx-6">
            <h1 className="text-3xl mt-5 mb-7 text-center sm:text-left">
              Nosotros ———
            </h1>

            <div className="flex flex-col md:flex-row justify-center items-center space-y-6 md:space-y-0 md:space-x-10">
              <img
                alt=""
                src="/ladyjustice.png"
                className="md:max-h-screen max-h-72 w-auto"
              />

              <div className="flex flex-col p-4">
                <div className="flex justify-center md:justify-start">
                  <img
                    alt=""
                    src="/logoV2.jpg"
                    className="md:max-h-64 max-h-32"
                  />
                </div>
                <p className="text-lg md:text-2xl mt-5">
                  Somos un equipo de profesionales con la más sólida formación
                  en materia legal. Nuestros principales valores
                  son: profesionalismo, el compromiso y la confidencialidad.
                </p>
                <p className="text-lg md:text-2xl mt-2">
                  Trabajamos de cerca con nuestros clientes, brindando una
                  solución a medida de sus necesidades, incorporando un enfoque
                  multidisciplinar que permite actuar en distintas áreas del
                  derecho con la más alta calidad profesional.
                </p>
                <p className="md:text-2xl text-xl mt-5 font-semibold">
                  POR ELLO
                </p>
                <p className="text-lg md:text-2xl mt-2">
                  Contamos con formación en las diferentes áreas del
                  conocimiento legal, administrativo, contable, económico y
                  financiero, que permite brindar un servicio integral en el
                  cual confiar.
                </p>
              </div>
            </div>
        </div>
      ) : (
        <div className="md:mx-48 sm:mx-6">
          <motion.div
            variants={fadeIn("left", 0.2)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false }}
          >
            <h1 className="text-3xl mt-5 mb-7 text-center sm:text-left">
              Nosotros ———
            </h1>

            <div className="flex flex-col md:flex-row justify-center items-center space-y-6 md:space-y-0 md:space-x-10">
              <img
                alt=""
                src="/ladyjustice.png"
                className="md:max-h-screen max-h-72 w-auto"
              />

              <div className="flex flex-col p-4">
                <div className="flex justify-center md:justify-start mb-5">
                  <img
                    alt=""
                    src="/logoV2.jpg"
                    className="md:max-h-52 max-h-32"
                  />
                </div>
                <p className="text-lg md:text-2xl mt-5">
                  Somos un equipo de profesionales con la más sólida formación
                  en materia legal. Nuestros principales valores
                  son: profesionalismo, el compromiso y la confidencialidad.
                </p>
                <p className="text-lg md:text-2xl mt-2">
                  Trabajamos de cerca con nuestros clientes, brindando una
                  solución a medida de sus necesidades, incorporando un enfoque
                  multidisciplinar que permite actuar en distintas áreas del
                  derecho con la más alta calidad profesional.
                </p>
                <p className="md:text-2xl text-xl mt-5 font-semibold">
                  POR ELLO
                </p>
                <p className="text-lg md:text-2xl mt-2">
                  Contamos con formación en las diferentes áreas del
                  conocimiento legal y administrativo, que permite brindar un servicio integral en el
                  cual confiar.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </>
  );
};

export default Nosotros;
